module.exports = __webpack_public_path__ + "img/ToDone.b94b8622.svg";